import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
} from '@material-ui/core';
import TableContainer from '@mui/material/TableContainer';

import NoDataLabel from '../common/NoDataLabel';
import AdStatsCreatorTable from './AdStatsCreatorTable';
import { getYoutubeAdStats } from '../../../../api_handlers/reporting';
import {
  unwrapResponse,
  rollUpCreators,
  buildOverallRows,
  buildCreatorRows,
  formatCell,
} from './adStatsUtils';

class AdStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overallRows: [],
      creatorRows: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
    // `reportingFetchV2` reads campaignId from the redux store at call time and
    // it is still null on first render, matching the sibling cards' pattern.
    setTimeout(() => this.getData(), 30);
  }

  async getData() {
    this.setState({ loading: true, error: null });

    try {
      const response = await getYoutubeAdStats(
        this.props.campaignId,
        this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null,
        this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null,
      );

      const payload = unwrapResponse(response);
      const creators = Array.isArray(payload.creators) ? payload.creators : [];
      const overall = payload.overall || rollUpCreators(creators);

      this.setState({
        overallRows: buildOverallRows(overall),
        creatorRows: buildCreatorRows(creators),
        loading: false,
      });
    } catch (error) {
      console.error('Failed to load YouTube ad stats', error);
      this.setState({
        overallRows: [],
        creatorRows: [],
        loading: false,
        error: 'Could not load organic vs paid data. Please try again.',
      });
    }
  }

  renderBody() {
    const { loading, error, overallRows, creatorRows } = this.state;

    if (loading) {
      return (
        <Grid container justify="center" style={{ padding: 24 }}>
          <CircularProgress size={24} />
        </Grid>
      );
    }

    if (error) {
      return (
        <Grid container style={{ padding: '7px 0px', color: 'gray' }}>
          {error}
        </Grid>
      );
    }

    if (overallRows.length === 0) {
      return <NoDataLabel offsetTop={10} />;
    }

    return (
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TableContainer>
            <Table size="small" aria-label="organic versus paid totals">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell align="right">Organic</TableCell>
                  <TableCell align="right">Paid</TableCell>
                  <TableCell align="right">Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {overallRows.map((row) => (
                  <TableRow key={row.key}>
                    <TableCell component="th" scope="row">
                      {row.label}
                    </TableCell>
                    <TableCell align="right">{formatCell(row.organic, row.format)}</TableCell>
                    <TableCell align="right">{formatCell(row.paid, row.format)}</TableCell>
                    <TableCell align="right">{formatCell(row.total, row.format)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item md={12}>
          <div className="dashboard-card-title" style={{ marginBottom: 6 }}>
            By Creator
          </div>
          <AdStatsCreatorTable rows={creatorRows} />
        </Grid>
      </Grid>
    );
  }

  render() {
    return (
      <Card style={{ width: '100%' }}>
        <CardContent>
          <Grid container>
            <Grid item md={12}>
              <Grid container style={{ fontSize: '15px', paddingBottom: '10px' }}>
                <Grid item md={4} className="dashboard-card-title">
                  Organic Vs Paid
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12}>
              {this.renderBody()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignId: state.campaign.campaignId,
  };
};

export default connect(mapStateToProps)(withRouter(AdStats));
